import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { EmailTemplatesDashboard } from '@core/models/case-communication/email-templates.model';
import { TemplateItem } from '@core/models/case-communication/template-item.model';
import { appRoutePaths, caseCommunicationRoutes } from '@core/routes/route-paths.constants';
import { HeaderService, LayoutService } from '@core/services';
import { CaseCommunicationService } from '@core/services/case-communication.service';
import { EmailTemplatesDashboardStoreService } from '@core/services/email-templates-dashboard-store.service';
import { AddNewEmailTemplateComponent } from '@modules/dialogs/add-new-email-template/add-new-email-template.component';
import { indicate } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-email-templates-dashboard',
    templateUrl: './email-templates-dashboard.component.html',
    styleUrls: ['./email-templates-dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailTemplatesDashboardComponent implements OnInit {
  static readonly componentName = 'EmailTemplatesDashboardComponent';
  
  public emailTemplates$: Observable<EmailTemplatesDashboard>;
  public sysText: any;
  public unsavedChangesSysText: any;
  public selectedIndex: number;
  public isLoadingNewEmailTemplateDialog$: Subject<boolean> = new Subject<boolean>(); 

  private destroy$: Subject<void> = new Subject<void>();

  get isMobile$(): Observable<boolean> {
    return this.layoutService.isMobile$();
  }

  constructor(
    private headerService: HeaderService,
    private store: EmailTemplatesDashboardStoreService,
    private layoutService: LayoutService,
    private dialog: MatDialog,
    private router: Router,
    private service: CaseCommunicationService
  ) { }

  ngOnInit(): void {
    this.emailTemplates$ = this.store.emailTemplates$;
    this.sysText = this.store.sysText;
    this.unsavedChangesSysText = this.store.sysText.unsavedChangesSysText;
    this.headerService.setTitle(this.sysText.emailTemplates["emailTemplates_header_title"]);

    if (this.store.selectedIndex) {
      this.selectedIndex = this.store.selectedIndex;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onCreate(sourceTemplate: TemplateItem): void {
    this.service.getAddNewTemplateDialog()
      .pipe(indicate(this.isLoadingNewEmailTemplateDialog$))
      .subscribe((res) => {
        const dialogConfig: MatDialogConfig = {
          id: AddNewEmailTemplateComponent.componentName,
          width: '550px',
          data: {
            addNewTemplateDialog: res,
            sourceId: sourceTemplate?.id,
            sourceName: sourceTemplate?.name,
            sourceType: sourceTemplate?.emailType.description,
            sysText: this.sysText.addNewEmailTemplate,
            unsavedChangesSysText: this.sysText.unsavedChanges
          }
        };
        
        this.dialog.open(AddNewEmailTemplateComponent, dialogConfig)
          .afterClosed()
          .pipe(filter((res) => !!res))
          .subscribe((res) => {
            this.router.navigate([`${appRoutePaths.EMAIL_TEMPLATES}/${caseCommunicationRoutes.TEMPLATE}`, res]);
          });
        });
  }

  public changeTab(event: MatTabChangeEvent) {
    this.store.selectedIndex = event.index;
  }
}
